import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { uniqBy } from 'lodash' ;

export const query = gql`
  query {
    tags {
      tag
    }
  }
`;

export const useIndicatorTags = () => {
  const { data: rawData, refetch, loading } = useQuery(query, {fetchPolicy: 'cache-first'});
  const data = uniqBy((rawData?.tags || []), 'tag').map(row => row.tag);
  return { data, refetch, loading };
};
